import React from 'react';
import PropTypes from 'prop-types';
import classes from '../syncPakVsSortPak.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import { stateOptions } from '../../../../../utils/data/data';
import Button from '../../../../_common/Form/Buttons/Button';
import { RangeDatePicker } from '../../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import accountHelpers from '../../../../../utils/accountHelpers';

const limit = 20;

const SyncPakVsSortPakFilters = ({
  setFilterData, filtersData, updateFilters, clearFilters, onChangeDate,
  healthCurrentPage, healthTotalPage, healthList, nextOptionListRequest, changeHealthSelect, downloadLoading,
}) => {
  const changeRequestData = (path, value) => {
    setFilterData((prev) => ({ ...prev, [path]: value }));
  };

  return (
    <div className={classes.filters_wrapper}>
      <div className={classes.filters}>
        <div className={classes.calendar}>
          <RangeDatePicker
            currentDate={filtersData}
            onChangeDate={onChangeDate}
            showLastYear
          />
        </div>

        <div className={classes.select_wrapper}>
          <Select
            label="All state"
            options={stateOptions}
            currentOption={filtersData.state}
            onChange={(option) => changeRequestData('state', option)}
          />
        </div>

        {accountHelpers.getUser().role === 'Admin' && (
        <div className={classes.select_wrapper}>
          <Select
            label="Health"
            nextOptionListRequest={nextOptionListRequest}
            options={healthList}
            totalPage={healthTotalPage}
            currentPage={healthCurrentPage}
            limit={limit}
            currentOption={filtersData.healthName}
            onChange={(option) => changeHealthSelect(option)}
            optionRenderPath="name"
            zIndex={31}
          />
        </div>
        )}
      </div>

      <div className={classes.btns_wrapper}>
        <Button
          title="Update"
          onClick={() => updateFilters('update')}
        />

        <Button
          title="Clear"
          clearButton
          onClick={clearFilters}
        />

        <Button
          title="Download"
          downloadButton
          onClick={() => updateFilters('download')}
          loading={downloadLoading}
        />
      </div>
    </div>
  );
};

SyncPakVsSortPakFilters.propTypes = {
  setFilterData: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  nextOptionListRequest: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  changeHealthSelect: PropTypes.func.isRequired,
  filtersData: PropTypes.object.isRequired,
  healthList: PropTypes.array.isRequired,
  healthCurrentPage: PropTypes.number.isRequired,
  healthTotalPage: PropTypes.number.isRequired,
  downloadLoading: PropTypes.bool.isRequired,
};

export default SyncPakVsSortPakFilters;
